import React from 'react'
import { Typography } from '@mui/material'

import { Copy, CopyContainer } from '../../../components/common/copy'

interface ErrorCaptureProps {
  title?: string
  subTitle?: string
  children?: React.ReactNode
}

const ErrorCapture = (props: ErrorCaptureProps) => {
  const { title, subTitle, children } = props

  return (
    <div>
      <CopyContainer padding="xlarge" noRightMargin={true}>
        <CopyContainer padding={{ bottom: 'xsmall' }}>
          <Copy>
            <Typography variant="h1">Error</Typography>
          </Copy>
        </CopyContainer>
        <CopyContainer padding={{ left: 'small' }}>
          <Copy>
            <Typography variant="h2">{title}</Typography>
            <Typography>{subTitle}</Typography>
            {children}
          </Copy>
        </CopyContainer>
      </CopyContainer>
    </div>
  )
}

export default ErrorCapture
